import { Pipe, PipeTransform } from '@angular/core';
import { PaymentOptionsEnum } from '@modules/core/enums';

@Pipe({
  name: 'paymentMethodInfo',
})
export class PaymentMethodInfoPipe implements PipeTransform {

  private paymentMethodInfoMatrix: Record<PaymentOptionsEnum, string> = {
    [PaymentOptionsEnum.ONLINE]: 'bookingPage.thankYouPage.paymentSection.methods.payOnline',
    [PaymentOptionsEnum.ON_SITE]: 'bookingPage.thankYouPage.paymentSection.methods.payOnSite',
  };

  transform(value: PaymentOptionsEnum): string {
    return this.paymentMethodInfoMatrix[value];
  }
}
